import {
  TreePine,
  Mountain,
  UtensilsCrossed,
  Sparkles,
  Users,
  Sun,
  Clock,
  CreditCard,
} from "lucide-react";
import ResortTemplate from "@/components/ResortTemplate";
import { mediaUrl } from "@/config/api";

const PyreneusResidence = () => {
  return (
    <ResortTemplate
      developmentSlug="pyreneus-residence"
      name="Pyreneus Residence"
      location="Pirenópolis, GO"
      highlightLabel="Refúgio na Serra"
      heroImage={mediaUrl("/empreendimentos/pyreneus-residence-banner.png")}
      heroDescription="DNA brasileiro e charme europeu no coração de Pirenópolis. Um refúgio em meio ao cerrado, com elegância, conforto e hospitalidade marcantes."
      rating={{ value: "4.7", reviews: "Hospedagem cinco estrelas em Pirenópolis" }}
      primaryCtaTo="/busca?empreendimento=Pyreneus%20Residence"
      about={{
        eyebrow: "Sobre o Empreendimento",
        title: "Elegância europeia em meio à natureza do cerrado",
        paragraphs: [
          "Em meio à natureza do cerrado, o Pyreneus Residence combina elegância de inspiração europeia com o conforto e a hospitalidade brasileira.",
          "Estrutura completa de lazer, acomodações amplas e experiências exclusivas para famílias, casais e grupos que buscam um refúgio sofisticado em Pirenópolis.",
        ],
        image: mediaUrl("/empreendimentos/pyreneus-galeria-1.png"),
        imageAlt: "Pyreneus Residence — natureza e experiências",
        stats: [
          { value: "Premium", label: "Localização" },
          { value: "12x", label: "Sem juros" },
          { value: "24/7", label: "Atendimento" },
        ],
      }}
      gallery={{
        title: "Cada detalhe pensado para encantar",
        description:
          "Da arquitetura ao paisagismo, ambientes que celebram a natureza do cerrado e a sofisticação europeia.",
        items: [
          {
            src: mediaUrl("/empreendimentos/pyreneus-residence-banner.png"),
            alt: "Pyreneus Residence — área da piscina",
            span: "big",
          },
          {
            src: mediaUrl("/empreendimentos/pyreneus-galeria-1.png"),
            alt: "Pyreneus Residence — natureza e experiências",
          },
          {
            src: mediaUrl("/empreendimentos/pyreneus-galeria-2.png"),
            alt: "Pyreneus Residence — destino em Pirenópolis",
            span: "wide",
          },
        ],
      }}
      features={{
        title: "Comodidades para uma estadia inesquecível",
        description: "Do bem-estar à gastronomia, tudo pensado para você aproveitar o melhor do cerrado.",
        items: [
          {
            icon: TreePine,
            title: "Natureza preservada",
            description: "Áreas verdes, trilhas e contato direto com o cerrado goiano.",
          },
          {
            icon: Mountain,
            title: "Aventura & Serra",
            description: "Acesso fácil às cachoeiras e atrações de Pirenópolis e Cocalzinho.",
          },
          {
            icon: Sparkles,
            title: "Spa & Wellness",
            description: "Tratamentos exclusivos em ambiente sereno para relaxamento total.",
          },
          {
            icon: UtensilsCrossed,
            title: "Gastronomia",
            description: "Restaurantes com cozinha brasileira refinada e influências europeias.",
          },
          {
            icon: Users,
            title: "Lazer Família",
            description: "Áreas kids, salão de jogos e programação para todas as idades.",
          },
          {
            icon: Sun,
            title: "Áreas de Lazer",
            description: "Piscinas, decks e ambientes ao ar livre para curtir o sol o ano todo.",
          },
          {
            icon: Clock,
            title: "Atendimento Flexível",
            description: "Recepção e concierge prontos para ajudar do check-in ao check-out.",
          },
          {
            icon: CreditCard,
            title: "Reservas Facilitadas",
            description: "PIX e cartão de crédito em até 12x sem juros para sua hospedagem.",
          },
        ],
      }}
      location_section={{
        title: "No coração de Pirenópolis",
        description:
          "A poucos minutos do centro histórico, com fácil acesso às cachoeiras, restaurantes e ateliês.",
        contact: {
          address: "Pyreneus Residence — Pirenópolis, GO",
          cityState: "Pirenópolis, GO",
          phone: "0800 300 6565 · (62) 3773-9600",
          travelInfo:
            "150 km de Goiânia e 165 km de Brasília — em média 2h pela rodovia.",
          mapEmbedUrl:
            "https://www.google.com/maps?q=Pirenópolis,+GO&output=embed&hl=pt-BR&z=13",
          directionsUrl:
            "https://www.google.com/maps/dir/?api=1&destination=Pirenópolis%2C%20GO",
        },
      }}
    />
  );
};

export default PyreneusResidence;
